import React from "react";
import { Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { EstadoFirmaColaborador } from "enum/EstadoFirmaColaborador";

const EtiquetaEstadoFirmaColaborador = ({ documento }) => {
    switch (documento.estadoFirmaColaborador) {
        case EstadoFirmaColaborador.NO_APLICA:
            return <Tag style={{ color: '#7f7f7f', marginRight: '0px' }}>No Aplica</Tag>;

        case EstadoFirmaColaborador.PENDIENTE:
            return <Tag color="gold" className="milegajo-ant-tag">PENDIENTE</Tag>;

        case EstadoFirmaColaborador.FIRMADO:
            return (
                <Tag color="green" className="milegajo-ant-tag pointer">
                    <EditOutlined /> FIRMADO
                </Tag>
            );

        default:
            return <Tag color="gold" className="milegajo-ant-tag">PENDIENTE</Tag>;
    }
}

export default EtiquetaEstadoFirmaColaborador;